/**
 * Meet hoe lang een bezoeker uit een Google-advertentie op een pagina blijft.
 *
 * De teller loopt alleen als het tabblad zichtbaar is, zodat een vergeten tabblad
 * geen bezoek van drie uur oplevert. De stand gaat naar de server na 15 seconden,
 * daarna elke 30 seconden, en bij het verlaten van de pagina. Die tussentijdse
 * pings zijn er voor de gevallen waarin de laatste beacon niet aankomt, wat op
 * mobiel regelmatig gebeurt.
 *
 * Het script doet niets zonder window.clwebAdSession. Die vlag wordt per request
 * gezet in resources/views/layout.antlers.html, binnen een nocache-blok.
 */
const FIRST_PING_MS = 15000;
const PING_INTERVAL_MS = 30000;
const ENDPOINT = '/ajax/track-pageview-duration';

export default function visitDuration () {
    if ( !window.clwebAdSession ) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if ( !token ) return;

    const url = window.location.pathname + window.location.search;

    let visibleMs = 0;
    let since = document.visibilityState === 'visible' ? Date.now() : null;
    let lastSent = 0;
    let timer = null;

    /** De opgetelde zichtbare tijd, inclusief de periode die nu loopt. */
    const elapsedSeconds = () => {
        const running = since === null ? 0 : Date.now() - since;

        return Math.round((visibleMs + running) / 1000);
    };

    const send = () => {
        const seconds = elapsedSeconds();

        // Niets te melden, of niets veranderd sinds de vorige keer.
        if ( seconds < 1 || seconds === lastSent ) return;

        lastSent = seconds;

        const payload = new FormData();
        payload.append('_token', token);
        payload.append('url', url);
        payload.append('seconds', String(seconds));

        // sendBeacon overleeft het afbreken van de pagina; fetch met keepalive is
        // de terugval voor browsers die hem weigeren.
        if ( navigator.sendBeacon?.(ENDPOINT, payload) ) return;

        fetch(ENDPOINT, { method: 'POST', body: payload, keepalive: true }).catch(() => {});
    };

    const startTimer = () => {
        if ( timer !== null ) return;

        timer = window.setTimeout(function tick () {
            send();
            timer = window.setTimeout(tick, PING_INTERVAL_MS);
        }, FIRST_PING_MS);
    };

    const stopTimer = () => {
        if ( timer === null ) return;

        window.clearTimeout(timer);
        timer = null;
    };

    document.addEventListener('visibilitychange', () => {
        if ( document.visibilityState === 'visible' ) {
            since = Date.now();
            startTimer();

            return;
        }

        // Verborgen: de teller pauzeert en de stand gaat meteen weg, want een
        // tabblad dat naar de achtergrond gaat komt op mobiel vaak niet terug.
        if ( since !== null ) {
            visibleMs += Date.now() - since;
            since = null;
        }

        stopTimer();
        send();
    });

    window.addEventListener('pagehide', () => {
        if ( since !== null ) {
            visibleMs += Date.now() - since;
            since = null;
        }

        stopTimer();
        send();
    });

    if ( since !== null ) startTimer();
}
